import { render, staticRenderFns } from "./modal-historico-situacao.vue?vue&type=template&id=5d617992&scoped=true"
import script from "./modal-historico-situacao.ts?vue&type=script&lang=ts&external"
export * from "./modal-historico-situacao.ts?vue&type=script&lang=ts&external"
import style0 from "./modal-historico-situacao.scss?vue&type=style&index=0&id=5d617992&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d617992",
  null
  
)

export default component.exports